import {PriceGuaranteeHintSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/article_detail_page/v1/service.types';
import {useTranslation} from '@aboutyou/i18n';
import {
  FONT_SIZES,
  Flyout,
  PrimaryContentPopperButton,
  SecondaryContentPopperButton,
  Text,
} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';
import {useBestPriceHintStateOpener} from './useBestPriceHintStateOpener';

export const BestPriceHintFlyout: React.FC<
  PriceGuaranteeHintSection['flyout'] & {
    onLearnMoreClick: VoidFunction;
  }
> = ({body, cta, headline, onLearnMoreClick}) => {
  const {t} = useTranslation();
  const {cancel, isOpen} = useBestPriceHintStateOpener();

  const handleCloseFlyout = () => {
    cancel();
  };

  return (
    <Flyout
      onClose={handleCloseFlyout}
      open={isOpen}
      data-testid="bestPriceHintFlyout"
      headerContent={
        <Text size="px16" weight="mediumHeavy" as="p" textAlignment="center">
          {headline}
        </Text>
      }
      bodyContent={
        <StyledText weight="mediumBold" color="Grey1">
          {body.tnc}
        </StyledText>
      }
      footerContent={
        <>
          <SecondaryContentPopperButton
            label={t('Close')}
            onClick={handleCloseFlyout}
          />
          <PrimaryContentPopperButton
            href={cta.linkTarget.url}
            onClick={onLearnMoreClick}
            label={cta.label}
          />
        </>
      }
    />
  );
};

const StyledText = styled(Text)`
  line-height: ${FONT_SIZES.px20};
`;
